import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type InitialType = {
  selectedTasks: number[];
  isDirty: boolean;
};

const initialState: InitialType = {
  selectedTasks: [],
  isDirty: false,
};

export const sprintsSlice = createSlice({
  name: 'sprints',
  initialState,
  reducers: (create) => ({
    setSelectedTasks: create.reducer(
      (state, action: PayloadAction<number[]>) => {
        return {
          ...state,
          selectedTasks: [...action.payload],
        };
      },
    ),
    setDirty: create.reducer((state) => {
      return {
        ...state,
        isDirty: true,
      };
    }),
    resetDirty: create.reducer((state) => {
      return {
        ...state,
        isDirty: false,
      };
    }),
  }),
});

export const sprintsReducer = sprintsSlice.reducer;
export const stateName = sprintsSlice.name;
